import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { mergeStyleSets } from '@fluentui/react';
import classNames from 'classnames';
const contentStyles = mergeStyleSets({
    hiddenClass: {
        display: 'none'
    }
});
export const HiddenComponentWrapper = ({ className, hide, children })=>{
    const containerClass = classNames({
        [className]: (className === null || className === void 0 ? void 0 : className.length) > 0,
        [contentStyles.hiddenClass]: hide
    });
    return /*#__PURE__*/ _jsx("div", {
        className: containerClass,
        children: children
    });
};
